import { GetSettingsResponseType } from '../apis/settings-server/types';
import { Channel, SettingGroup, Section } from '../components/App/sections/types';
import { ChannelFilter } from '../consts/channel-filter';
import { TranslationFunction } from 'i18next';
import { channelDescriptionFormatter, channelTitleFormatter } from './translation-formatters';

export function parseSectionsFromResponse(
  settingsResponse: GetSettingsResponseType,
  t: TranslationFunction,
  { shouldShowMobile, shouldShowEmail, shouldShowSMS }
  ): Channel[] {
  const { channelSettings } = JSON.parse(JSON.stringify(settingsResponse));

  delete channelSettings[ChannelFilter.BROWSER];

  if (!shouldShowMobile) {
    delete channelSettings[ChannelFilter.MOBILE];
  }
  if (!shouldShowEmail) {
    delete channelSettings[ChannelFilter.EMAIL];
  } else if (!channelSettings[ChannelFilter.EMAIL]) {
    channelSettings[ChannelFilter.EMAIL] = { sections: [] };
  }
  if (!shouldShowSMS) {
    delete channelSettings[ChannelFilter.SMS];
  }

  const channels =  Object.keys(channelSettings).map(channelName => {
    const section = channelSettings[channelName];
    const subsections = section.sections.filter(it => it.groupSettings.length > 0).map(subsection => {
      const groups = subsection.groupSettings.map(group => {
        return { groupTitle: group.title, groupKey: group.groupKey, isMuted: group.settingsData.mute || false } as SettingGroup;
      });
      return { sectionTitle: subsection.title, sectionKey: subsection.sectionKey, groups } as Section;
    });

    const channelKey = channelName || ChannelFilter.ALL;

    return {
      channelKey,
      channelTitle: t(channelTitleFormatter(channelName.toLowerCase())),
      channelDescription: t(channelDescriptionFormatter(channelName.toLowerCase())),
      sections: subsections
    } as Channel;
  });

  const orderedChannels = Object.keys(ChannelFilter);
  return channels
    .sort((channelA, channelB) =>
      orderedChannels.indexOf(channelA.channelKey) - orderedChannels.indexOf(channelB.channelKey));
}
